<template>
<Box @close="close({})">
    <template #top>Devoluciones x Item</template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-title-1">{{ prv_nombre }}</div>
                <b-table :data="devoluciones" :current-page="1" :paginated="true" pagination-order="is-centered">
                    <template slot-scope="props">
                        <b-table-column label="Fecha devolución" header-class="is-info">{{ props.row.dei_fecha_registro }}</b-table-column>
                        <b-table-column label="Cantidad" header-class="is-info">{{ props.row.did_cantidad }}</b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </template>
</Box>
</template>

<script>
import { DevolucionItemsService, ResponseStatus } from "../../services"
import { Toast } from "../../util"
import { Box } from "../components"

export default {
    name: "DevolucionesxItem",
    components: {
        Box
    },
    props: {
        aid_id: {
            type: Number,
            default: null
        },
        prv_nombre: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            devoluciones: []
        }
    },
    methods: {
        close({
            view = ""
        }) {
            this.$emit("close", {
                view
            })
        },
        buscar() {
            DevolucionItemsService
                .buscarDevolucionesxItems({
                    devolucion_items_detalle: {
                        asi_id: this.asi_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.devoluciones = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        }
    },
    mounted() {
        this.buscar()
    }
}
</script>

<style scoped></style>